import { render } from "./DrymatterIcon.vue?vue&type=template&id=e9d306c4&scoped=true"
import script from "./DrymatterIcon.vue?vue&type=script&lang=js"
export * from "./DrymatterIcon.vue?vue&type=script&lang=js"

import "./DrymatterIcon.vue?vue&type=style&index=0&id=e9d306c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9d306c4"]])

export default __exports__